import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Collapse } from "antd";
const { Panel } = Collapse;

class StageEnemiesCollapse extends Component {
  getEnemyDesc(enemies) {
    if (typeof enemies !== "undefined") {
      const timeTriggerList = [];
      enemies.forEach((enemy, index) => {
        const enemyDesc1 =
          (enemy.number === 0 ? "Infinite" : enemy.number) + " ";

        const enemyDesc2 =
          " spawns " +
          (enemy.is_boss === 1 ? "as the boss " : "") +
          "after " +
          enemy.time_trigger +
          " second" +
          (enemy.time_trigger === 1 ? "" : "s") +
          ", delay " +
          enemy.spawn_interval +
          " seconds";

        if (
          enemy.base_trigger !== "100%" &&
          (index !== 0
            ? enemy.base_trigger !== enemies[index - 1].base_trigger
            : true)
        ) {
          const baseTrigger =
            "When the base reaches " + enemy.base_trigger + " HP:";
          timeTriggerList.push(<p></p>);
          timeTriggerList.push(<p>{baseTrigger}</p>);
          timeTriggerList.push(
            <li>
              {enemyDesc1}
              <Link
                to={
                  "/enemyinfo/" +
                  enemy.enemy_no +
                  "/" +
                  enemy.enemy_name_en +
                  "/" +
                  enemy.amplification
                }
              >
                {enemy.enemy_name_en}
                {enemy.number === 1 || enemy.enemy_name_en.slice(-1) === "s"
                  ? ""
                  : "s"}
              </Link>
              {enemyDesc2}
            </li>
          );
        } else {
          timeTriggerList.push(
            <li>
              {enemyDesc1}
              <Link
                to={
                  "/enemyinfo/" +
                  enemy.enemy_no +
                  "/" +
                  enemy.enemy_name_en +
                  "/" +
                  enemy.amplification
                }
              >
                {enemy.enemy_name_en}
                {enemy.number === 1 || enemy.enemy_name_en.slice(-1) === "s"
                  ? ""
                  : "s"}
              </Link>
              {enemyDesc2}
            </li>
          );
        }
      });
      return (
        <ul
          style={{
            whiteSpace: "normal",
            float: "left",
            width: "100%",
            height: "auto",
            wordWrap: "break-word",
          }}
        >
          {timeTriggerList}
        </ul>
      );
    }
  }

  render() {
    // const innerHeight = this.props.viewportHeight;

    return (
      <Collapse defaultActiveKey={["1"]}>
        <Panel header="Background" key="1">
          {this.getEnemyDesc(this.props.enemies)}
        </Panel>
      </Collapse>
    );
  }
}

export default StageEnemiesCollapse;



// WEBPACK FOOTER //
// ./src/components/table/StageEnemiesCollapse.js